import { render, staticRenderFns } from "./AppReviewMediaIndicator.vue?vue&type=template&id=1d1532da&scoped=true"
import script from "./AppReviewMediaIndicator.vue?vue&type=script&lang=js"
export * from "./AppReviewMediaIndicator.vue?vue&type=script&lang=js"
import style0 from "./AppReviewMediaIndicator.vue?vue&type=style&index=0&id=1d1532da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1532da",
  null
  
)

export default component.exports